import { PostSeoHead_post$data } from '@/components/Seo/post/__generated__/PostSeoHead_post.graphql'
import { NextSeoProps } from 'next-seo'
import { useMemo } from 'react'
import { router, urlify } from '@lifedot/router'
import { replacementImageForPost } from '@lifedot/constants/images'

export const usePostSeoHead = (
  post: PostSeoHead_post$data | null,
  page: number
): NextSeoProps => {
  const title = useMemo(
    () =>
      page > 1
        ? `${page}ページ | ${post?.h1} | お墓探しならライフドット`
        : `${post?.h1} | お墓探しならライフドット`,
    [page, post?.h1]
  )
  const description = useMemo(
    () => post?.meta_description ?? '',
    [post?.meta_description]
  )
  const url = useMemo(
    () => urlify(router.post(post?.slug ?? '', page)),
    [page, post?.slug]
  )
  const imageUrl = useMemo(
    () => post?.image?.url ?? replacementImageForPost.path,
    [post?.image?.url]
  )
  const additionalMetaTags = useMemo(
    () => [
      ...(post?.image?.url ? [{ name: 'thumbnail', content: imageUrl }] : []),
      ...(post?.meta_keywords
        ? [{ name: 'keywords', content: post.meta_keywords }]
        : []),
      ...(post?.meta_robots
        ? [{ name: 'robots', content: post.meta_robots }]
        : [])
    ],
    [imageUrl, post?.image?.url, post?.meta_keywords, post?.meta_robots]
  )
  return useMemo(() => {
    return {
      title,
      description,
      additionalMetaTags,
      openGraph: {
        url,
        description,
        title,
        images: [{ url: imageUrl }]
      },
      canonical: url
    }
  }, [additionalMetaTags, description, imageUrl, title, url])
}
